<table class="w-100 align-middle mb-1">
    <tbody>
        <tr>
            <td class="text-left"><label class="input-label">{{ 'Selection values:' | translate }} </label></td>
            <td class="text-right fit-cell">
                <label class="input-label" for="useCustomKey">
                    {{'classification.other.use_custom_key' | translate}}
                </label>
                <ui-switch style="padding-inline-start: 15px; vertical-align: middle;
                    height: 32px; display: inline-block;"
                            id="useCustomKey"
                            (change)="saveSelectValues($event)"
                            [(ngModel)]="fieldOptions.useCustomKey">
                </ui-switch>
            </td>
        </tr>
    </tbody>
</table>

<table class="table table-striped table-bordered align-middle bg-white"
       id="selections">
    <tbody cdkDropList
           [cdkDropListData]="fieldOptions.data.values"
           (cdkDropListDropped)="dropped($event)">
    <tr class="table-bordered">
        <td></td>
        <td *ngIf="fieldOptions.useCustomKey"><span><label
                class="input-label">{{ 'classification.other.key' | translate }}</label></span></td>
        <td><span><label
                class="input-label field-required">{{ 'classification.other.value' | translate }}</label></span></td>
        <td></td>
    </tr>
    <tr cdkDrag *ngFor="let selection of fieldOptions.data.values; let i = index"
        class="table-bordered">
        <td class="text-center fit-cell">
                <span><i class="fas fa-arrows-alt handle"></i></span>
            </td>
            <td *ngIf="fieldOptions.useCustomKey"><span>{{ selection.value }}</span></td>
            <td ><span>{{ selection.label }}</span></td>
            <td class="text-center fit-cell">
                <confirmation [showTrashIcon]="true"
                              [question]="'confirm.areyousure'"
                              (isConfirmed)="deleteSelection($event, i, selection);">
                </confirmation>
            </td>
        </tr>
    </tbody>
    <tfoot>
        <tr class="table-bordered">
            <td></td>
            <td *ngIf="fieldOptions.useCustomKey">
                <input class="form-control"
                       type="text"
                       name="newKey"
                       [(ngModel)]="newKey">
            </td>
            <td>
                <input class="form-control"
                       type="text"
                       name="newSelection"
                       [(ngModel)]="newSelection">
            </td>
            <td class="text-center fit-cell">
                <button class="addBtn services-icon--add"
                        type="submit"
                        (click)="addSelection(newKey, newSelection); newSelection='';newKey=''">{{ 'general.add' | translate}}
      </button>
            </td>
        </tr>
    </tfoot>
</table>
